// 'use server'
import * as React from 'react'
import { TLanguages } from '../../config/locale'
import { LocaleProvider } from './LocaleContext'
import createLocale from './createLocale'

type TLocale = ReturnType<typeof createLocale>

type TLoadLocaleFn = (lang: TLanguages) => Promise<{ [k: string]: string }>

type TPageProps = {
  params: Promise<{
    lang: TLanguages
    [key: string]: string
  }>
  searchParams?: Promise<{ [key: string]: string | string[] | undefined }>
  children?: React.ReactNode
}

export type TPageLocaleProviderProps = TPageProps & {
  t: TLocale
}

const createWithPageLocaleProvider =
  <P extends TPageLocaleProviderProps>(loadDefaultLocale: TLoadLocaleFn) =>
  (WrappedComponent: React.ComponentType<TPageLocaleProviderProps>, loadPageLocale?: TLoadLocaleFn) => {
    return async function C(props: TPageProps) {
      const params = await props.params
      const locale = (await loadPageLocale?.(params.lang)) || (await loadDefaultLocale(params.lang))
      const t: TLocale = createLocale(locale)

      return (
        <LocaleProvider locale={locale}>
          <WrappedComponent {...props} t={t} />
        </LocaleProvider>
      )
    }
  }

export default createWithPageLocaleProvider
